export default "__VITE_ASSET__CSEdWCIE__"